export enum EMAIL_MARKETING_SOURCES {
    WEB = 'web',
}
